module.exports = __webpack_public_path__ + "static/media/edition.5f8c7a4c.jpg";